import { render, staticRenderFns } from "./disclosure_hierarchy.vue?vue&type=template&id=56855320"
import script from "./disclosure_hierarchy.vue?vue&type=script&lang=js"
export * from "./disclosure_hierarchy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports